module.exports = __webpack_public_path__ + "static/img/gift_card.82273cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/gift_card.png
// module id = ZVQ2
// module chunks = 35